<template>
  <header
    id="header-top"
    class="module-top"
    v-bind:class="{ isBorderBottom: isBorderBottom }"
    v-bind:style="{ backgroundColor: bgColor }"
  >
    <div class="module-top-left">
      <div class="icon-fanhui" @click="back">
        <img src="~assets/images/icon_arr_l@3x.png" />
      </div>
    </div>
    <div class="module-top-title">{{ title | slice }}</div>
    <div class="module-top-right" :style="modRightStyle">
      <slot name="mod-right"></slot>
    </div>
  </header>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '加载中'
    },
    show: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: '#fff'
    },
    isBorderBottom: {
      type: Boolean,
      default: true
    },
    isShowModRight: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    slice(val) {
      return val.length > 12 ? `${val.slice(0, 12)}...` : val
    }
  },
  methods: {
    back() {
      this.$emit('back')
    }
  },
  data() {
    return {
      showTop: true
    }
  },
  computed: {
    modRightStyle() {
      return {
        visibility: this.isShowModRight ? 'visible' : 'hidden'
      }
    }
  }
}
</script>
<style lang="scss" scoped rel="stylesheet/scss">
@import '~assets/css/mixin.scss';
.module-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: rem(80px);
  padding: 0 rem(20px);
  /*position: fixed;*/
  top: 0;
  left: 0;
  z-index: 201;
  /*background: #fff;*/
  font-size: rem(36px);
  &.isBorderBottom {
    @include border(bottom);
  }
  & + * {
    /*padding-top: rem(80px);*/
  }
  &-left {
  }
  &-right {
    visibility: hidden;
  }
}
.module-top-left {
  display: flex;
  width: rem(100px);
}
.icon-fanhui {
  margin-right: rem(20px);
  img {
    width: rem(27px);
  }
}
.icon-store {
  color: #999;
  width: rem(60px);
  text-align: center;
}
.module-top-right {
  width: rem(100px);
}
</style>
